import { useStore } from '@/store/useStore';
import {
  getExperimentValue,
  CASINO_IN_GAME_WALLET_EXPERIMENT,
} from '@/utilities/logger/amplitude/experiments/getExperimentValue';
import { trackExperimentExposure } from '@/utilities/logger/amplitude/experiments/experimentExposure';

/**
 * In-game (FGP) balance feature gate. Mirrors v2's
 * `casinoInGameWalletV2Enabled === 'on'`. Plain (non-hook) getter so it can be
 * called from the balance-fetch helpers, not just React components.
 */
export const isInGameBalanceEnabled = (): boolean => {
  trackExperimentExposure(CASINO_IN_GAME_WALLET_EXPERIMENT);

  return (
    getExperimentValue(
      useStore.getState().amplitudeExperiments,
      CASINO_IN_GAME_WALLET_EXPERIMENT,
    ) === 'on'
  );
};
